import { Chip, CHIP_SIZE, CHIP_TYPE, COLORS } from '@repo/design-system/index'
import { n_achievement } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'

interface AchievementChipProps {
  size: CHIP_SIZE
}

export const StageUnlockedChip = ({ size }: AchievementChipProps) => {
  const { t } = useTranslation()

  return (
    <Chip type={CHIP_TYPE.ACTIONABLE} size={size} customBgColor={COLORS.GRAY100}>
      <Chip.Label customTxtColor={COLORS.PURPLE600}>{t(n_achievement.label.stage_unlocked)}</Chip.Label>
    </Chip>
  )
}

export const NewAchievementChip = ({ size }: AchievementChipProps) => {
  const { t } = useTranslation()

  return (
    <Chip type={CHIP_TYPE.ACTIONABLE} size={size} customBgColor={COLORS.YELLOW100}>
      <Chip.Label customTxtColor={COLORS.YELLOW500}>{t(n_achievement.label.new)}</Chip.Label>
    </Chip>
  )
}
